import { Building2, CheckCircle, Mic2 } from "lucide-react";
import { SubSection } from "../SubSection";
import { NavItem } from "../NavItem";
import MusicNoteOutlinedIcon from "@mui/icons-material/MusicNoteOutlined";
import QueueMusicOutlinedIcon from "@mui/icons-material/QueueMusicOutlined";
import AlbumOutlinedIcon from "@mui/icons-material/AlbumOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

interface LibrarySectionProps {
  isCollapsed: boolean;
  currentPath: string;
  /** Holds CATALOG_READ_PUBLISHER_DIRECTORY (seller + admin) — resolved once in the Sidebar. */
  canSeePublishers: boolean;
}

export function LibrarySection({
  isCollapsed,
  currentPath,
  canSeePublishers,
}: LibrarySectionProps) {
  return (
    <SubSection title="Library" icon={CheckCircle} isCollapsed={isCollapsed}>
      <NavItem
        icon={MusicNoteOutlinedIcon}
        label="Tracks"
        path="/tracks"
        isCollapsed={isCollapsed}
        isActive={currentPath === "/tracks"}
      />
      <NavItem
        icon={AlbumOutlinedIcon}
        label="Albums"
        path="/albums"
        isCollapsed={isCollapsed}
        isActive={currentPath === "/albums"}
        // Activated: previously disabled placeholder
      />
      <NavItem
        icon={Mic2}
        label="Artists"
        path="/artists"
        isCollapsed={isCollapsed}
        isActive={currentPath === "/artists"}
        // Activated: previously disabled placeholder
      />
      {canSeePublishers ? (
        <NavItem
          icon={Building2}
          label="Publishers"
          path="/publishers"
          isCollapsed={isCollapsed}
          isActive={currentPath.startsWith("/publishers")}
          iconSize={20}
        />
      ) : null}
      <NavItem
        icon={QueueMusicOutlinedIcon}
        label="Playlists"
        path="/playlists"
        isCollapsed={isCollapsed}
        isActive={currentPath === "/playlists"}
      />
      <NavItem
        icon={SearchOutlinedIcon}
        label="Search"
        path="/search"
        isCollapsed={isCollapsed}
        isActive={currentPath === "/search"}
      />
      {/* No separate "Assistant" item: /search IS the assistant now (2026-07-29),
          so the Search entry above leads to Sol for every user it can serve and
          to the classic search for the rest. A second nav item would advertise
          the same surface twice. */}
    </SubSection>
  );
}
